// extracted by mini-css-extract-plugin
export default {"menuBlock":"FF-z","title":"GF-z","nav":"HF-z","flexCell":"IF-z","facetLink":"JF-z"};